import { useContext } from 'react'

import { ADULT_AGE_SELECT } from '../../Constants'
import { RenderAge } from '../RenderAge'
import { PAXContext } from './PaxContext'

/**
 * Adult age render here
 */
function AdultAgeRender({ template }) {
	const [{ activeRoom = 1, costingInfo = [] }, dispatch] =
		useContext(PAXContext)
	const currentRoom = costingInfo[activeRoom - 1]
	const adultAges = currentRoom.adultAges || []

	return (
		<RenderAge
			paxCount={adultAges}
			onSelectAction={({ age, index }) => {
				dispatch({
					type: ADULT_AGE_SELECT,
					payload: {
						age: age,
						adultIndex: index,
					},
				})
			}}
			paxType="adult"
			template={template}
		/>
	)
}

export default AdultAgeRender
